export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export function formatShortDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  return (
    d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) +
    ' · ' +
    d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  );
}

export function formatFollowers(n: number | null | undefined): string {
  if (!Number.isFinite(n) || (n ?? 0) <= 0) return '0';
  const v = n as number;
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(v % 1_000_000 === 0 ? 0 : 1) + 'M';
  if (v >= 1_000) return (v / 1_000).toFixed(v % 1_000 === 0 ? 0 : 1) + 'k';
  return String(v);
}

export function formatBytes(b: number | null | undefined): string {
  if (!b) return '';
  return b < 1048576 ? `${(b / 1024).toFixed(0)} KB` : `${(b / 1048576).toFixed(1)} MB`;
}

export function parseFollowersStr(str: string | undefined | null): number {
  if (!str) return 0;
  const tok = str.trim().split(/[\s,]/)[0].toUpperCase();
  const n = parseFloat(tok);
  if (isNaN(n)) return 0;
  if (tok.includes('M')) return n * 1_000_000;
  if (tok.includes('K')) return n * 1_000;
  return n;
}
